var map = {
	"./AntDesign.ttf": 26429,
	"./Entypo.ttf": 47288,
	"./EvilIcons.ttf": 2326,
	"./Feather.ttf": 29601,
	"./FontAwesome.ttf": 86255,
	"./FontAwesome5_Brands.ttf": 64839,
	"./FontAwesome5_Regular.ttf": 28034,
	"./FontAwesome5_Solid.ttf": 15083,
	"./Fontisto.ttf": 51078,
	"./Foundation.ttf": 34923,
	"./Ionicons.ttf": 49588,
	"./MaterialCommunityIcons.ttf": 91178,
	"./MaterialIcons.ttf": 86378,
	"./Octicons.ttf": 20231,
	"./SimpleLineIcons.ttf": 95675,
	"./Zocial.ttf": 41521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68097;